import React, { FunctionComponent, useState, useCallback } from 'react';
import { EmailCheck } from '../EmailCheck';
import { AppointmentForm } from '../AppointmentForm';
import { EmailCheckResponseModel } from '../../../../models';
import { EmailCheckFormFieldsModel } from '../../../../models/EmailCheckFormFieldsModel';
import { PexipPlugin } from '../PexipPlugin';

export const Step1: FunctionComponent = () => {
    /*const [showPexipPlugin, setShowPexipPlugin] = useState(false);
    const [showAppointmentForm, setShowAppointmentForm] = useState(false);
    const [showEmailCheck, setShowEmailCheck] = useState(true);
    const [formData, setFormData] = useState<EmailCheckFormFieldsModel | null>(null);
    const [emailCheckResponse, setEmailCheckResponse] = useState<EmailCheckResponseModel | null>(
        null,
    );

    const handleEmailCheck = useCallback(
        (response: EmailCheckResponseModel, formData: EmailCheckFormFieldsModel) => {
            const { success, showPexipForm } = response;
            if (!success) return;
            setFormData(formData);
            setEmailCheckResponse(response);
            setShowEmailCheck(false);
            showPexipForm ? setShowPexipPlugin(true) : setShowAppointmentForm(true);
        },
        [setShowEmailCheck],
    );

    return (
    <>
      {showEmailCheck && <EmailCheck handleEmailCheck={handleEmailCheck} />}
      {(showPexipPlugin && emailCheckResponse && formData) && <PexipPlugin emailCheckResponse={emailCheckResponse} formData={formData} />}
      {(showAppointmentForm && formData) && <AppointmentForm formData={formData} />}
    </>
  );*/

    // only show AppointmentForm
    return <AppointmentForm />;
};
